import React, { useContext } from "react";
import MenuItem from "./MenuItem";
import { addParentMenu } from "app/services/menuService";
import { useEffect } from "react";
import { useState } from "react";
import AddPopOver from "./AddPopOver";
import { FaLayerGroup } from "react-icons/fa";
import { Col, Row } from "react-bootstrap";
import { AppContext } from "app/appContext";
import usePagePermission from "app/hooks/usePagePermission";

const Menu = () => {
  const { canView, canAdd, canEdit, canDelete } = usePagePermission();

  const context = useContext(AppContext);

  const [menuState, setMenuState] = useState([]);

  const [isShow, setIsShow] = useState(false);

  const [target, setTarget] = useState(null);
  const [isCollapseAll, setIsCollapseAll] = useState(0);

  const getMenuHandler = async () => {
    setMenuState(context.navData);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const value = {
      name: e.target.name.value,
      icon: e.target.icon.value,
      path: e.target.path?.value,
      description: e.target.description.value,
    };

    const newMenu = await addParentMenu(value);

    setMenuState(newMenu.data);
    setIsShow(false);
  };

  useEffect(() => {
    getMenuHandler();
  }, [context.navData]);

  return (
    <>
      <div className="mb-3">
        <Row>
          <Col>
            <div className="row">
              <div className="col-10">
                <AddPopOver
                  target={target}
                  setTarget={setTarget}
                  setIsShow={setIsShow}
                  isShow={isShow}
                  ParentMenu="ParentMenu"
                  handleSubmit={handleSubmit}
                />
              </div>
              <div className="col-2">
                {
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-xs  float-end"
                    onClick={() => setIsCollapseAll(isCollapseAll + 1)}
                  >
                    <FaLayerGroup />
                  </button>
                }
              </div>
            </div>
            <hr className="my-3" />
          </Col>
          <Col></Col>
        </Row>
      </div>
      {menuState?.map((item, index) => (
        <MenuItem
          disableUpOrder={index == 0}
          disableDownOrder={menuState.length == index + 1}
          key={item.id}
          item={item}
          menuState={menuState}
          setMenuState={setMenuState}
          isCollapseAll={isCollapseAll}
        />
      ))}
    </>
  );
};

export default Menu;
